import React from "react";
import { formatItalianDate } from "../../../utils/functions/date-utils";
import { useSelector } from "react-redux";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Divider, IconButton } from "@mui/material";

const EventDetail = ({ event, onClose }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <div className="p-4 min-w-full h-full">
      <div className="w-full flex justify-between items-center ">
        <div className="w-full ">
          <div className="text-center">
            <h3 className="m-0">{event.event.title}</h3>
            <small style={{ color: colorPrimary }}>
              {formatItalianDate(event.event.start)}
            </small>
          </div>
        </div>
        <div>
          <IconButton onClick={onClose}>
            <CloseRoundedIcon className="text-red-600" />
          </IconButton>
        </div>
      </div>
      <Divider />
      <div className="py-4">
        <p>{event.event.extendedProps.description}</p>
      </div>
    </div>
  );
};

export default EventDetail;
